import React, { useEffect, useState } from 'react';

import { Radio } from 'semantic-ui-react';

import AccommodationsService from '../services/AccommodationsService';

// Fallback for backward compatibility or if API fails
const defaultTranslationLanguageNames = {
  en: 'English',
  es: 'Spanish',
  fr_fr: 'French',
  de_de: 'German',
  it_it: 'Italian',
  pt: 'Portuguese',
  nl_nl: 'Dutch',
  sv_se: 'Swedish',
  da_dk: 'Danish',
  no_nb: 'Norwegian',
  fi_fi: 'Finnish',
  is_is: 'Icelandic',
  ca_es: 'Catalan',
  eu_es: 'Basque',
  gl_es: 'Galician',
  ar_ar: 'Arabic',
  he_il: 'Hebrew',
  ja_jp: 'Japanese',
  ko_kr: 'Korean',
  zh_cn: 'Chinese',
  lv_lv: 'Latvian'
};

// Export for backward compatibility
export const translationLanguageNames = defaultTranslationLanguageNames;

const TranslationLanguageSelector = ({
  selectedLanguage = null, // Changed from selectedLanguages array to single value
  onSelectLanguage // Changed from onToggleLanguage
} = {}) => {
  const [translationLanguageNames, setTranslationLanguageNames] = useState(defaultTranslationLanguageNames);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const loadTranslations = async () => {
      const languages = await AccommodationsService.fetchTranslationLanguages();
      if (languages && Object.keys(languages).length > 0) {
        setTranslationLanguageNames(languages);
      }
      setIsLoading(false);
    };
    loadTranslations();
  }, []);

  const languages = Object.keys(translationLanguageNames);

  if (isLoading) {
    return (
      <div className='translation-language-selector'>
        <div className='selector-body'>Loading languages...</div>
      </div>
    );
  }

  return (
    <div className='translation-language-selector'>
      <div className='selector-header'>
        <span className='selector-header-label'>Languages</span>
      </div>
      <div className='selector-body'>
        {languages.map((lang) => {
          const isChecked = selectedLanguage === lang;
          return (
            <label className='language-option' key={lang}>
              <Radio
                checked={isChecked}
                onChange={() => onSelectLanguage(lang)}
              />
              <span>{translationLanguageNames[lang] || lang}</span>
            </label>
          );
        })}
      </div>
    </div>
  );
};

export default TranslationLanguageSelector;

